'use client'

import { CheckCircle } from 'lucide-react'
import type { VerificationLevel } from '@/types/api.types'

interface VerificationBadgeProps {
  level: VerificationLevel
  size?: 'sm' | 'md' | 'lg'
}

const LEVEL_CONFIG = {
  none: null,
  basic: {
    color: 'var(--color-text-muted)',
    tooltip: 'Verified email domain',
  },
  standard: {
    color: 'var(--color-brand-indigo)',
    tooltip: 'Verified Company',
  },
  premium: {
    color: 'var(--color-accent)',
    tooltip: 'Trusted Partner',
  },
} as const

const SIZE_MAP = {
  sm: 'h-3.5 w-3.5',
  md: 'h-4 w-4',
  lg: 'h-5 w-5',
} as const

export function VerificationBadge({ level, size = 'md' }: VerificationBadgeProps) {
  const config = LEVEL_CONFIG[level]
  if (!config) return null

  return (
    <span
      title={config.tooltip}
      aria-label={config.tooltip}
      className="inline-flex items-center"
    >
      <CheckCircle
        className={SIZE_MAP[size]}
        style={{ color: config.color }}
        fill={config.color}
        strokeWidth={0}
      />
    </span>
  )
}
